import $api from "..";
import { AxiosResponse } from "axios";
import type { IFilesDisplay } from "../common/api_interfaces/files/IFilesDisplay";
import type { IGetFilesDisplayData, IGetFilesTaskDisplayData } from "../common/api_interfaces/files/IGetFilesDisplayData";
import type { IFileResponse } from "../common/api_interfaces/files/IFileResponse";

export default class FileService {
    async uploadTempFile(file: any): Promise<AxiosResponse<IFileResponse>> {
        const formData = new FormData();
        formData.append("file", file, encodeURI(file.name));        

        return $api.post<IFileResponse>("uploadTempFile", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    }

    async addFileToProject(file: any, projectId: number, userId: number): Promise<AxiosResponse<IFileResponse>> {
        const formData = new FormData();
        formData.append("file", file, encodeURI(file.name));
        formData.append("projectId", `${projectId}`);
        formData.append("userId", `${userId}`);

        return $api.post<IFileResponse>("Project/addFile", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    } 

    async addFileTask(file: File, taskId: number): Promise<AxiosResponse<IFileResponse>> {
        const formData = new FormData();
        formData.append("file", file, encodeURI(file.name));
        formData.append("taskId", `${taskId}`);

        return $api.post<IFileResponse>("Project/addFileTask", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    }

    async downloadFile(fileId: string): Promise<AxiosResponse<Blob>> {
        return $api.get(`/Project/getFile?fileId=${fileId}`, {
            responseType: "blob",
        });
    }

    async getProjectFiles(projectId: number): Promise<AxiosResponse<IFileResponse>> {
        return $api.get<IFileResponse>(`/Project/getFile?projectId=${projectId}`);
    }

    async getFilesDisplayData(body: IGetFilesDisplayData): Promise<AxiosResponse<IFilesDisplay>> {
        return $api.post<IFilesDisplay>(`/Project/getFiles`, body);
    }

    async getFilesTaskDisplayData(body: IGetFilesTaskDisplayData): Promise<AxiosResponse<IFilesDisplay>> {
        return $api.post<IFilesDisplay>(`/Project/Board/Task/getTaskFiles`, body);
    }

    // async getFileFilterOptions(): Promise<AxiosResponse<IFileFilterOptions>> {
    //     return $api.get<IFileFilterOptions>(`/Project/getFilesFilters`);
    // }

    async deleteFile(filesIds: number[]): Promise<AxiosResponse<void>> {
        return $api.post<void>("Project/deleteFiles", filesIds);
    }

    async refreshUserAvatar(userId: number): Promise<AxiosResponse<void>> {
    return $api.get<void>(`/userAvatar/${userId}`, {
        headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
        }
    });
}
}
